import React from 'react';
import './Franchise.css';

const Franchise = () => {
    return (
        <div className="franchise-page container">
            <h1 className="franchise-title">Franchising Urban Bites</h1>
            <div className="franchise-content">
                <p className="franchise-intro">We've initiated the franchising of SF Hole in the Wall in specific territories.</p>
                <div className="cta-container">
                    <a href="https://crustfranchising.com" target="_blank" rel="noopener noreferrer" className="btn-primary franchise-btn">LEARN MORE</a>
                </div>

                <div className="ways-to-start">
                    <h2>WAYS TO GET STARTED</h2>
                    <div className="start-options">
                        <div className="option-card">
                            <h3>Schedule a Meeting</h3>
                            <p>Discover more about this exciting opportunity.</p>
                            <a href="https://booking.setmore.com/scheduleappointment/54d2ab38-c94f-4d8a-90f6-f214765dd984" target="_blank" rel="noopener noreferrer" className="link-text">Schedule Now &rarr;</a>
                        </div>
                        <div className="option-card">
                            <h3>Contact Us</h3>
                            <p>Fill out a contact form and tell us the area you're interested in.</p>
                            <a href="https://crustfranchising.com" target="_blank" rel="noopener noreferrer" className="link-text">Contact Form &rarr;</a>
                        </div>
                        <div className="option-card">
                            <h3>Email Corporate</h3>
                            <p>Directly email our corporate team.</p>
                            <a href="mailto:corporate@crustfranchising.com" className="link-text">Email Us &rarr;</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Franchise;
